<template>
  <span>{{ city }}</span>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    location: String,
  },
  data() {
    return {
      city: '',
      interval: '',
    };
  },
  mounted() {
    var self = this;
    // eslint-disable-next-line no-unused-vars
    var s = 0;
    self.interval = setInterval(function () {
      if (self.location != 'undefined,undefined') {
        self.getRegeo(self.location).then((res) => {
          self.city = res;
        });
        clearInterval(self.interval);
        self.interval = null;
        console.log(self.interval);
        s++;
      }
    }, 1000);
  },
  methods: {
    ...mapActions('other', ['getRegeo']),
  },
};
</script>
